import { render, staticRenderFns } from "./NewToggle.vue?vue&type=template&id=56606fad&scoped=true&"
import script from "./NewToggle.vue?vue&type=script&lang=js&"
export * from "./NewToggle.vue?vue&type=script&lang=js&"
import style0 from "./NewToggle.vue?vue&type=style&index=0&id=56606fad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56606fad",
  null
  
)

export default component.exports